import { IsoLocale } from "@izettle/constants"

export const baseUrl = "/seller-verification"

export const docifySupportContactUrl: Map<IsoLocale, string> = new Map([
  [IsoLocale.enUS, "https://www.paypal.com/us/smarthelp/contact-us"],
  [IsoLocale.enGB, "https://www.zettle.com/gb/help/contact"],
  [IsoLocale.deDE, "https://www.zettle.com/de/help/contact"],
  [IsoLocale.frFR, "https://www.zettle.com/fr/help/contact"],
  [IsoLocale.nlNL, "https://www.zettle.com/nl/help/contact"],
  [IsoLocale.svSE, "https://www.zettle.com/se/help/contact"],
  [IsoLocale.svFI, "https://www.zettle.com/se/help/contact"],
  [IsoLocale.fiFI, "https://www.zettle.com/fi/help/contact"],
  [IsoLocale.nbNO, "https://www.zettle.com/no/help/contact"],
  [IsoLocale.daDK, "https://www.zettle.com/dk/help/contact"],
  [IsoLocale.esES, "https://www.zettle.com/es/help/contact"],
  [IsoLocale.itIT, "https://www.zettle.com/it/help/contact"],
  [IsoLocale.esMX, "https://www.zettle.com/mx/help/contact"],
])
